import type { Booking } from '@/entities/bookings/booking.entity';
import { VehicleExtraType } from '@carvia/ros-client-types';
import { getBookedExtras, getCustomBookedExtras } from '@/utils/pricing.utils';

export const getInclusiveAndExtraKm = (booking: Booking, customInclusiveKm?: number) => {
  const customExtras = getCustomBookedExtras(booking.priceCalculation);
  const couponKm = customExtras
    .filter(
      (extra) => extra.isAdditional && extra.customVehicleExtraType === VehicleExtraType.EXTRA_KM,
    )
    .reduce((total, extra) => total + Number(extra.value ?? 0), 0);

  const customExtraKm = customExtras
    .filter(
      (extra) => !extra.isAdditional && extra.customVehicleExtraType === VehicleExtraType.EXTRA_KM,
    )
    .reduce((total, extra) => total + Number(extra.value ?? 0), 0);

  const bookedExtraKm = getBookedExtras(booking.priceCalculation)
    .filter((extra) => extra.vehicleExtraSnapshot?.type === VehicleExtraType.EXTRA_KM)
    .reduce((total, extra) => total + Number(extra.vehicleExtraOptionSnapshot?.value ?? 0), 0);

  // Catalog EXTRA_KM is replaced by a non-additional custom EXTRA_KM when one exists.
  const extraKm = customExtraKm > 0 ? customExtraKm : bookedExtraKm;
  const inclusiveKm = customInclusiveKm ?? booking.priceCalculation.inclusiveKm ?? 0;

  return {
    inclusiveKm,
    extraKm,
    couponKm,
    sum: extraKm + inclusiveKm + couponKm,
  };
};
